import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {MatDialog} from '@angular/material/dialog';
import {CatalogueDetailComponent} from '../catalogue-detail/catalogue-detail.component';

@Component({
    selector: 'app-catalogue-p-table',
    templateUrl: './catalogue-p-table.component.html',
    styleUrls: ['./catalogue-p-table.component.css']
})
export class CataloguePTableComponent implements OnInit {

    @Input() list: any[] = [];
    @Output() sort = new EventEmitter<any>();
    dataSource = new MatTableDataSource<any>();
    readColumns: String[] = [
        'categorie',
        'prodId',
        'prodNm',
        'action',

    ];

    constructor(
        public dialog: MatDialog,
        public translate: AppTranslateService,
        private appTranslateService: AppTranslateService,
    ) {
    }

    ngOnInit(): void {
        this.loadDataSource();

    }

    loadDataSource() {
        this.dataSource.data = this.list;
    }

    ngOnChanges(changes: SimpleChanges): void {

        const {list} = changes;
        if (list.currentValue !== list.previousValue) {
            this.loadDataSource();
        }
    }

    onSortChange($event: any) {
        this.sort.emit({
            nameCol: $event.active as any,
            direction: ($event.direction.toUpperCase() || 'ASC') + ' nulls last',
        });
    }

    hamza(item) {

    }

    opendialogannonce(item) {
        const dialogRef = this.dialog.open(CatalogueDetailComponent, {
            disableClose: true,
            direction: this.appTranslateService.getDir(),
            width: '1500px',
            data: {...item}
        });

        dialogRef.afterClosed().subscribe(result => {


        });
    }

}
